import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

  constructor(public api:ApiService, private route: ActivatedRoute) { }

  ngOnInit(){
    this.api.post("SPDO=select",{database:'user',where:"email = '"+this.route.snapshot.params['token']+"' OR token = '"+this.route.snapshot.params['token']+"'"}).then((res:any)=>{
      if(res.data && res.data[0]){
        this.api.adminUser.next(res.data[0]);
      }else{
        this.api.error("Vous n'avez pas les droits pour accéder à cette page");
        this.api.goTo('login');
      }  
    });
  }


  onResized(event:ResizedEvent) {
    if(window.self !== window.top){
      window.parent.postMessage({"height": event.newRect.height}, "*");
    }
  }
}
